import React from 'react'
import M from 'materialize-css'
import { Link } from 'react-router-dom'

const Dell = function (props) {

    React.useEffect(function () {
        M.AutoInit()
        document.title = 'MOCOS | Dell Computer Repair'
        return function () { }
        // eslint-disable-next-line
    })

    return (
        <main>
            <div className='row' style={{ marginTop: "1rem" }}>
                <div className='col s12 m10 offset-m1'>
                    <a href='/'
                        className='btn-small red'
                    ><i className='material-icons left'>home</i>Go Home</a>
                    <div className='row' style={{marginTop:'2rem'}}>
                        <div className='col s12 m6 shell'>
                            <div className='card hoverable'>
                                <div className='card-image'>
                                    <img src='/dell.png' alt='pic' className='materialboxed' width='100%' />
                                </div>
                                <div className='card-action center'>
                                    <p>Dell</p>
                                </div>
                            </div>
                        </div>
                        <div className='col s12 m6'>
                            <h5 className='red-text center'>SERVICE WE PROVIDE</h5>
                            <div className='row'>
                                <div className='col s6'>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Speaker Replacement.</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>  Mirror Replacement.</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Battery Replacement.</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Nework Spare Parts Replacement.</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Camera Replacement</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Touch Pad Fixing</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Mike Replacement.</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Motherboard Replacement</i>
                                    </h6>
                                </div>
                                <div className='col s6'>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Computer Housing Replacement</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Electrical System Replacement</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Reinstalling the programs</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Keyboard Repair</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>Power React</i>
                                    </h6>
                                    <h6 >
                                        <i className='material-icons left'>timeline</i>
                                        <i>RAM & Processor React.</i>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='center spell'>
                        <Link to={'/contactus'} className='btn-large red'>
                            <i className='material-icons large left'>mail</i>
                            contact us now</Link>
                    </div>
                    <h5 className='center red-text'><i>DELL models we are dealing eith</i></h5>
                    <h6 className='center red-text'><i>Please do not hesitate to contact us if your computer is not listed here!</i></h6>
                    <div className='row'>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>Inspiron</span>
                                </div>
                            </div>
                        </div>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>G Series</span>
                                </div>
                            </div>
                        </div>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>Studio</span>
                                </div>
                            </div>
                        </div>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>xps</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>Vostro</span>
                                </div>
                            </div>
                        </div>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>Latitude</span>
                                </div>
                            </div>
                        </div>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>Adamo</span>
                                </div>
                            </div>
                        </div>
                        <div className='col s6 m3'>
                            <div className='card'>
                                <div className='card-content'>
                                    <span className='card-title center'>xps</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default React.memo(Dell)